<template>
  <div class="user-data-payment">
    <h2>{{ $t('component.userData.payment.header') }}</h2>
    <p>{{ $t('component.userData.payment.description') }}</p>

    <section class="data-table">
      <section class="data-header">
        <div class="data-col col1">{{ $t('component.userData.payment.labelType') }}</div>
        <div class="data-col col2" v-if="isPaymentBlikMethodSet">{{ $t('component.userData.payment.labelStatus') }}</div>
        <div class="data-col col3" v-if="isPaymentBlikMethodSet">{{ $t('component.userData.payment.labelCardValidity') }}</div>
        <div class="data-col col4" v-if="isPaymentBlikMethodSet">{{ $t('component.userData.payment.labelCardNumber') }}</div>
        <div class="data-col col5"></div>
      </section>
      <section class="data-content">
        <div class="data-row">
          <div class="data-col col1">
            <div class="label-mobile">{{ $t('component.userData.payment.labelType') }}</div>
            <strong>{{ $t('component.userData.payment.creditCardType') }}</strong>
          </div>
          <div class="data-col col2" v-if="isPaymentBlikMethodSet">
            <div class="label-mobile">{{ $t('component.userData.payment.labelStatus') }}</div>
            <span type="success" v-if="isStatusActive(payment[0].status)">{{ $t('component.userData.payment.statusActive') }}</span>
            <span type="info" v-if="isStatusInactive(payment[0].status)">{{ $t('component.userData.payment.statusInactive') }}</span>
            <span type="warning" v-if="isStatusPending(payment[0].status)">{{ $t('component.userData.payment.statusPending') }}</span>
            <span type="danger" v-if="isStatusFailure(payment[0].status)">{{ $t('component.userData.payment.statusFailure') }}</span>
          </div>
          <div class="data-col col3" v-if="isPaymentBlikMethodSet">
            <div class="label-mobile">{{ $t('component.userData.payment.labelCardValidity') }}</div>
            <strong v-if="payment[0].cardData">{{ payment[0].cardData.validityMonth }}/{{ payment[0].cardData.validityYear }}</strong>
            <strong v-if="!payment[0].cardData">-</strong>
          </div>
          <div class="data-col col4" v-if="isPaymentBlikMethodSet">
            <div class="label-mobile">{{ $t('component.userData.payment.labelCardNumber') }}</div>
            <strong v-if="payment[0].cardData">**** **** **** {{ payment[0].cardData.mask }}</strong>
            <strong v-if="!payment[0].cardData">-</strong>
          </div>
          <div class="data-col col5">
            <el-button type="danger"
                       icon="el-icon-delete"
                       plain
                       size="mini"
                       @click="removeCard"
                       v-if="isPaymentMethodSet"
                       :title="$t('component.userData.payment.a11y.buttonRemoveMethod')">
              {{ $t('component.userData.payment.buttonRemoveCreditCard') }}
            </el-button>
            <el-button v-if="!isPaymentMethodSet"
                       @click="goToAddPaymentMethod"
                       type="success"
                       icon="el-plus"
                       size="small">
              {{ $t('component.userData.payment.buttonAddCreditCard') }}
            </el-button>
          </div>
        </div>
        <div class="data-row">
          <div class="data-col col1">
            <div class="label-mobile">{{ $t('component.userData.payment.labelType') }}</div>
            <strong>{{ $t('component.userData.payment.blikType') }}</strong>
          </div>
          <div class="data-col col2" v-if="isPaymentBlikMethodSet">
            <div class="label-mobile">{{ $t('component.userData.payment.labelStatus') }}</div>
            <span type="success" v-if="isStatusActive(paymentBlik[0].status)">{{ $t('component.userData.payment.statusActive') }}</span>
            <span type="info" v-if="isStatusInactive(paymentBlik[0].status)">{{ $t('component.userData.payment.statusInactive') }}</span>
            <span type="warning" v-if="isStatusPending(paymentBlik[0].status)">{{ $t('component.userData.payment.statusPending') }}</span>
            <span type="danger" v-if="isStatusFailure(paymentBlik[0].status)">{{ $t('component.userData.payment.statusFailure') }}</span>
          </div>
          <div class="data-col col3" v-if="isPaymentBlikMethodSet">
            <div class="label-mobile">{{ $t('component.userData.payment.labelCardValidity') }}</div>
            <strong>{{ $t('component.userData.payment.blikValidity') }}</strong>
          </div>
          <div class="data-col col4" v-if="isPaymentBlikMethodSet">
            <div class="label-mobile">{{ $t('component.userData.payment.labelCardNumber') }}</div>
            <strong>{{ $t('component.userData.payment.blikNumber') }}</strong>
          </div>
          <div class="data-col col5">
            <el-button type="danger" icon="el-icon-delete" plain size="mini" @click="removeBlik" v-if="isPaymentBlikMethodSet"
                       :title="$t('component.userData.payment.a11y.buttonRemoveMethod')">
              {{ $t('component.userData.payment.buttonRemoveBlik') }}
            </el-button>
            <el-button v-if="!isPaymentBlikMethodSet"
                       @click="goToAddPaymentBlikMethod"
                       style="margin-top: 10px"
                       type="success"
                       icon="el-plus"
                       size="small">
              {{ $t('component.userData.payment.buttonAddBlik') }}
            </el-button>
          </div>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
import PaymentMixin from '@/common/mixins/UserData/Payment.mixin'

export default {
  name: 'UserDataPayment',
  mixins: [PaymentMixin]
}
</script>

<style src="../../assets/scss/table.scss" lang="scss"></style>
<style lang="scss">
@import '../../assets/scss/variables';
.user-data-payment {
  @media (min-width: $res-m) {
    .col1 { width: 180px }
    .col2 { width: 100px }
    .col3 { width: 120px }
    .col4 { width: 140px }
    .col5 { width: auto }
  }
  @media (min-width: $res-l) {
    .col1 { width: 220px }
    .col2 { width: 140px }
    .col3 { width: 160px }
    .col4 { width: 180px }
    .col5 { width: auto }
  }
  @media (min-width: $res-xl) {
    .col1 { width: 260px }
    .col2 { width: 160px }
    .col3 { width: 180px }
    .col4 { width: 200px }
    .col5 { width: auto }
  }
}
</style>
